import COLORS from "../../assets/Colors";
import theme from "../../assets/theme";
import { Button, withStyles } from "@material-ui/core";
// import { Center } from "../../styles/component/style";
import styled from "styled-components";
const PrimaryBtnStyle = {
  root: {
    backgroundColor: COLORS.LIGHT_BLUE_LABEL,
    color: COLORS.PRIMARY_WHITE,
    fontFamily: theme.fonts.primaryFontSemiBold,
    fontWeight: "bold",
    fontSize: 14,
    width: "100%",
    textTransform: "none",
    borderRadius: 6,
    padding: "8px 22px",
    border: `1px solid ${COLORS.LIGHT_BLUE_LABEL}`,
    transition: "300ms",
    "&:hover": {
      backgroundColor: COLORS.BORDER_GREY,
      borderColor: COLORS.BORDER_GREY,
      // transform: "translate(0, -4px)",
    },
    "&:active": {
      backgroundColor: COLORS.LIGHT_BLUE_LABEL,
      borderColor: COLORS.LIGHT_BLUE_LABEL,
    },
    "&:focus": {
      borderColor: COLORS.LIGHT_BLUE_LABEL,
    },
  },
  label: {
    lineHeight: 1,
  },
  disabled: {
    borderColor: "rgba(0, 0, 0, 0.26)",
    opacity: 0.6,
    color: `${COLORS.PRIMARY_WHITE} !important`,
  },
};

const OutlinedPrimaryBtnStyle = {
  root: {
    backgroundColor: COLORS.LIGHT_BLUE_COLOR,
    color: COLORS.TRANSCRIPT_GRAY,
    fontFamily: theme.fonts.primaryFontBold,
    fontWeight: "bold",
    fontSize: 14,
    width: "100%",
    textTransform: "none",
    borderRadius: 5,
    padding: "8px 22px",
    border: `1px solid ${COLORS.TRANSCRIPT_GRAY}`,
    transition: "300ms",
    "&:hover": {
      backgroundColor: COLORS.LIGHT_BLUE_COLOR,
      borderColor: COLORS.TRANSCRIPT_GRAY,
      // transform: "translate(0, -4px)",
    },
    "&:active": {
      backgroundColor: COLORS.PRIMARY_WHITE,
      borderColor: COLORS.TRANSCRIPT_GRAY,
    },
    "&:focus": {
      borderColor: COLORS.TRANSCRIPT_GRAY,
    },
  },
  label: {
    lineHeight: 1,
  },
  disabled: {
    borderColor: "rgba(0, 0, 0, 0.26)",
    opacity: 0.6,
  },
};

const SecondaryBtnStyle = {
  root: {
    background: "none",
    margin: "auto",
    fontFamily: theme.fonts.primaryFontBold,
    fontSize: 14,
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: COLORS.LIGHT_BLUE_LABEL,
    cursor: "pointer",
    border: "none",
    outline: "none",
    textTransform: "none",
    padding: "6px 14px",
    transition: "300ms",
    "&:hover": {
      background: "none",
      color: COLORS.LIGHT_BLUE_LABEL,
      transform: "translate(0, -4px)",
    },
    "&:active": {},
    "&:focus": {},
  },
  label: {
    lineHeight: 1,
  },
  disabled: {
    borderColor: "rgba(0, 0, 0, 0.26)",
  },
};

export const ActionButton = styled.button`
  border-radius: 4px;
  border: none;
  background-color: ${COLORS.BTN_GREEN};
  width: 171px;
  height: 42px;
  font-family: ${theme.fonts.primaryFontBold};
  font-size: 14px;
  text-align: center;
  color: ${COLORS.PRIMARY_WHITE};
  outline: none;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  margin-left: 23px;
`;

export const SecondaryActionButton = styled.button`
  border-radius: 4px;
  border: solid 1px ${COLORS.BTN_GREEN};
  background-color: ${COLORS.PRIMARY_WHITE};
  width: 171px;
  height: 42px;
  font-family: ${theme.fonts.primaryFontBold};
  font-size: 14px;
  text-align: center;
  color: ${COLORS.BTN_GREEN};
  outline: none;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  margin-left: 23px;
`;

export const PrimaryCTAButton = withStyles(PrimaryBtnStyle)(Button);
export const SecondaryCTAButton = withStyles(SecondaryBtnStyle)(Button);
export const PrimaryOutlinedCTAButton = withStyles(OutlinedPrimaryBtnStyle)(
  Button,
);
